// main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import gsap from 'gsap'
import 'tailwindcss/tailwind.css'
import '@/assets/css/style.css'
import i18n from './i18n'

const app = createApp(App)
gsap.registerPlugin(ScrollTrigger)
app.use(router)
app.use(i18n) // 确保这行在 mount 之前

app.mount('#app')